import { render, staticRenderFns } from "./ScreeningQuestionControl.vue?vue&type=template&id=2637abde&scoped=true"
import script from "./ScreeningQuestionControl.vue?vue&type=script&lang=ts"
export * from "./ScreeningQuestionControl.vue?vue&type=script&lang=ts"
import style0 from "./ScreeningQuestionControl.vue?vue&type=style&index=0&id=2637abde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637abde",
  null
  
)

export default component.exports